/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The time unit is to define the response model separation.
 */
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["DAY"] = "DAY";
    TimeUnit["HOUR"] = "HOUR";
    TimeUnit["MONTH"] = "MONTH";
})(TimeUnit || (TimeUnit = {}));
